"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: subscription/merchant-info.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fsubscription%2Fmerchant-info.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.merchantInfoGroupNameToJSON = exports.merchantInfoGroupNameFromJSON = exports.merchantActionToJSON = exports.merchantActionFromJSON = exports.merchantSourceToJSON = exports.merchantSourceFromJSON = exports.MerchantInfoGroup = exports.MerchantInfoUpcomingPayment = exports.MerchantInfo = exports.MerchantInfoGroupName = exports.MerchantAction = exports.MerchantSource = void 0;
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const merchant_1 = require("../common/merchant");
const merchant_link_status_1 = require("./merchant-link-status");
const protobufPackage = 'com.step.subscription.proto';
var MerchantSource;
(function (MerchantSource) {
    MerchantSource["INVALID_SOURCE"] = "INVALID_SOURCE";
    /**
     * BLOCKED - Blocked merchant as reported by merchant service.
     */
    MerchantSource["BLOCKED"] = "BLOCKED";
    /**
     * ONLINE - Merchant with online transactions.
     */
    MerchantSource["ONLINE"] = "ONLINE";
    /**
     * KNOT - Merchant integrated via Knot.
     */
    MerchantSource["KNOT"] = "KNOT";
    MerchantSource["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MerchantSource || (exports.MerchantSource = MerchantSource = {}));
var MerchantAction;
(function (MerchantAction) {
    MerchantAction["INVALID_MERCHANT_ACTION"] = "INVALID_MERCHANT_ACTION";
    /**
     * NONE - Do not display any actions.
     */
    MerchantAction["NONE"] = "NONE";
    /**
     * BLOCK - Display Block button.
     */
    MerchantAction["BLOCK"] = "BLOCK";
    /**
     * UNBLOCK - Display Unblock button.
     */
    MerchantAction["UNBLOCK"] = "UNBLOCK";
    MerchantAction["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MerchantAction || (exports.MerchantAction = MerchantAction = {}));
var MerchantInfoGroupName;
(function (MerchantInfoGroupName) {
    MerchantInfoGroupName["INVALID_INFO_GROUP"] = "INVALID_INFO_GROUP";
    MerchantInfoGroupName["INFO_GROUP_NEW"] = "INFO_GROUP_NEW";
    MerchantInfoGroupName["INFO_GROUP_TOP"] = "INFO_GROUP_TOP";
    MerchantInfoGroupName["INFO_GROUP_BLOCKED"] = "INFO_GROUP_BLOCKED";
    MerchantInfoGroupName["INFO_GROUP_OTHER"] = "INFO_GROUP_OTHER";
    MerchantInfoGroupName["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MerchantInfoGroupName || (exports.MerchantInfoGroupName = MerchantInfoGroupName = {}));
function createBaseMerchantInfo() {
    return {
        merchant: merchant_1.Merchant.fromPartial({}),
        isBlocked: false,
        upcomingPayment: undefined,
        sources: [],
        status: merchant_link_status_1.MerchantLinkStatus.INVALID_MERCHANT_LINK_STATUS,
        action: MerchantAction.INVALID_MERCHANT_ACTION,
        cardId: '',
        additionalEnrichedIds: [],
    };
}
exports.MerchantInfo = {
    fromJSON(object) {
        const message = {
            merchant: isSet(object.merchant)
                ? merchant_1.Merchant.fromJSON(object.merchant)
                : merchant_1.Merchant.fromPartial({}),
            isBlocked: isSet(object.isBlocked) ? globalThis.Boolean(object.isBlocked) : false,
            action: isSet(object.action)
                ? merchantActionFromJSON(object.action)
                : MerchantAction.INVALID_MERCHANT_ACTION,
        };
        if (isSet(object.upcomingPayment)) {
            message.upcomingPayment = exports.MerchantInfoUpcomingPayment.fromJSON(object.upcomingPayment);
        }
        if (globalThis.Array.isArray(object?.sources)) {
            message.sources = object.sources.map((e) => merchantSourceFromJSON(e));
        }
        if (isSet(object.status)) {
            message.status = (0, merchant_link_status_1.merchantLinkStatusFromJSON)(object.status);
        }
        if (isSet(object.cardId)) {
            message.cardId = globalThis.String(object.cardId);
        }
        if (globalThis.Array.isArray(object?.additionalEnrichedIds)) {
            message.additionalEnrichedIds = object.additionalEnrichedIds.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = merchant_1.Merchant.toJSON(message.merchant);
        }
        if (message.isBlocked !== false) {
            obj.isBlocked = message.isBlocked;
        }
        if (message.upcomingPayment !== undefined) {
            obj.upcomingPayment = exports.MerchantInfoUpcomingPayment.toJSON(message.upcomingPayment);
        }
        if (message.sources?.length) {
            obj.sources = message.sources.map((e) => merchantSourceToJSON(e));
        }
        if (message.status !== undefined &&
            message.status !== merchant_link_status_1.MerchantLinkStatus.INVALID_MERCHANT_LINK_STATUS) {
            obj.status = (0, merchant_link_status_1.merchantLinkStatusToJSON)(message.status);
        }
        if (message.action !== MerchantAction.INVALID_MERCHANT_ACTION) {
            obj.action = merchantActionToJSON(message.action);
        }
        if (message.cardId !== undefined && message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.additionalEnrichedIds?.length) {
            obj.additionalEnrichedIds = message.additionalEnrichedIds;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantInfo();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? merchant_1.Merchant.fromPartial(object.merchant)
            : merchant_1.Merchant.fromPartial({});
        message.isBlocked = object.isBlocked ?? false;
        message.upcomingPayment =
            (object.upcomingPayment !== undefined && object.upcomingPayment !== null)
                ? exports.MerchantInfoUpcomingPayment.fromPartial(object.upcomingPayment)
                : undefined;
        message.sources = object.sources?.map((e) => e) || [];
        message.status = object.status ?? merchant_link_status_1.MerchantLinkStatus.INVALID_MERCHANT_LINK_STATUS;
        message.action = object.action ?? MerchantAction.INVALID_MERCHANT_ACTION;
        message.cardId = object.cardId ?? '';
        message.additionalEnrichedIds = object.additionalEnrichedIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseMerchantInfoUpcomingPayment() {
    return { amount: amount_1.Amount.fromPartial({}), date: date_1.LocalDate.fromPartial({}) };
}
exports.MerchantInfoUpcomingPayment = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            date: isSet(object.date) ? date_1.LocalDate.fromJSON(object.date) : date_1.LocalDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.date !== undefined) {
            obj.date = date_1.LocalDate.toJSON(message.date);
        }
        return obj;
    },
    create(base) {
        return exports.MerchantInfoUpcomingPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantInfoUpcomingPayment();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.date = (object.date !== undefined && object.date !== null)
            ? date_1.LocalDate.fromPartial(object.date)
            : date_1.LocalDate.fromPartial({});
        return message;
    },
};
function createBaseMerchantInfoGroup() {
    return { name: MerchantInfoGroupName.INVALID_INFO_GROUP, merchants: [] };
}
exports.MerchantInfoGroup = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.name)) {
            message.name = merchantInfoGroupNameFromJSON(object.name);
        }
        if (globalThis.Array.isArray(object?.merchants)) {
            message.merchants = object.merchants.map((e) => exports.MerchantInfo.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined && message.name !== MerchantInfoGroupName.INVALID_INFO_GROUP) {
            obj.name = merchantInfoGroupNameToJSON(message.name);
        }
        if (message.merchants?.length) {
            obj.merchants = message.merchants.map((e) => exports.MerchantInfo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.MerchantInfoGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantInfoGroup();
        message.name = object.name ?? MerchantInfoGroupName.INVALID_INFO_GROUP;
        message.merchants = object.merchants?.map((e) => exports.MerchantInfo.fromPartial(e)) || [];
        return message;
    },
};
function merchantSourceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SOURCE':
            return MerchantSource.INVALID_SOURCE;
        case 1:
        case 'BLOCKED':
            return MerchantSource.BLOCKED;
        case 2:
        case 'ONLINE':
            return MerchantSource.ONLINE;
        case 3:
        case 'KNOT':
            return MerchantSource.KNOT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MerchantSource.UNRECOGNIZED;
    }
}
exports.merchantSourceFromJSON = merchantSourceFromJSON;
function merchantSourceToJSON(object) {
    switch (object) {
        case MerchantSource.INVALID_SOURCE:
            return 'INVALID_SOURCE';
        case MerchantSource.BLOCKED:
            return 'BLOCKED';
        case MerchantSource.ONLINE:
            return 'ONLINE';
        case MerchantSource.KNOT:
            return 'KNOT';
        case MerchantSource.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.merchantSourceToJSON = merchantSourceToJSON;
function merchantActionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MERCHANT_ACTION':
            return MerchantAction.INVALID_MERCHANT_ACTION;
        case 1:
        case 'NONE':
            return MerchantAction.NONE;
        case 2:
        case 'BLOCK':
            return MerchantAction.BLOCK;
        case 3:
        case 'UNBLOCK':
            return MerchantAction.UNBLOCK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MerchantAction.UNRECOGNIZED;
    }
}
exports.merchantActionFromJSON = merchantActionFromJSON;
function merchantActionToJSON(object) {
    switch (object) {
        case MerchantAction.INVALID_MERCHANT_ACTION:
            return 'INVALID_MERCHANT_ACTION';
        case MerchantAction.NONE:
            return 'NONE';
        case MerchantAction.BLOCK:
            return 'BLOCK';
        case MerchantAction.UNBLOCK:
            return 'UNBLOCK';
        case MerchantAction.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.merchantActionToJSON = merchantActionToJSON;
function merchantInfoGroupNameFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INFO_GROUP':
            return MerchantInfoGroupName.INVALID_INFO_GROUP;
        case 1:
        case 'INFO_GROUP_NEW':
            return MerchantInfoGroupName.INFO_GROUP_NEW;
        case 2:
        case 'INFO_GROUP_TOP':
            return MerchantInfoGroupName.INFO_GROUP_TOP;
        case 3:
        case 'INFO_GROUP_BLOCKED':
            return MerchantInfoGroupName.INFO_GROUP_BLOCKED;
        case 4:
        case 'INFO_GROUP_OTHER':
            return MerchantInfoGroupName.INFO_GROUP_OTHER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MerchantInfoGroupName.UNRECOGNIZED;
    }
}
exports.merchantInfoGroupNameFromJSON = merchantInfoGroupNameFromJSON;
function merchantInfoGroupNameToJSON(object) {
    switch (object) {
        case MerchantInfoGroupName.INVALID_INFO_GROUP:
            return 'INVALID_INFO_GROUP';
        case MerchantInfoGroupName.INFO_GROUP_NEW:
            return 'INFO_GROUP_NEW';
        case MerchantInfoGroupName.INFO_GROUP_TOP:
            return 'INFO_GROUP_TOP';
        case MerchantInfoGroupName.INFO_GROUP_BLOCKED:
            return 'INFO_GROUP_BLOCKED';
        case MerchantInfoGroupName.INFO_GROUP_OTHER:
            return 'INFO_GROUP_OTHER';
        case MerchantInfoGroupName.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.merchantInfoGroupNameToJSON = merchantInfoGroupNameToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=merchant-info.js.map